import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 4rem 1rem;

  .form-container {
    max-width: 600px;
    width: 100%;
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
  }

  .title {
    text-align: center;
    margin-bottom: 1rem;
  }

  .underline {
    margin: 0 auto;
    width: 5rem;
    height: 0.25rem;
    background: var(--clr-primary-5);
    margin-top: 0.5rem;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  label {
    font-weight: 600;
    margin-bottom: 0.25rem;
    display: block;
    color: var(--clr-grey-1);
  }

  input,
  textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-3);
    border-radius: var(--radius);
    font-size: 1rem;
  }

  textarea {
    resize: vertical;
    min-height: 120px;
  }

.terms {
  font-size: 0.95rem;
  line-height: 1.4;
  margin-top: 1rem; /* Adjust spacing as needed */
  padding-left: 0; /* Remove left padding since checkbox is visible */
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.terms input {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  position: static;
  opacity: 1;
  z-index: auto;
}

.terms label {
  color: var(--clr-grey-5);
  font-weight: 500;
  cursor: pointer;
}

.terms a {
  color: var(--clr-primary-5);
  font-weight: 600;
  text-decoration: underline;
}

  button {
    padding: 0.75rem 1.5rem;
    background: #b17c5b;
    color: white;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: var(--spacing);
    transition: var(--transition);
  }

  button:hover {
    background: #8f6246;
  }

  
  .terms-section,
.refund-section,
.shipping-section,
.privacy-section {
  max-width: 600px;
  width: 100%;
  margin-top: 3rem;
  color: var(--clr-grey-5);
  line-height: 1.8;
  text-align: left;

  h3 {
    margin-bottom: 1rem;
    color: var(--clr-grey-1);
    font-size: 1.25rem;
  }

  div {
    max-height: 300px;
    overflow-y: auto;
    padding: 1rem 0.75rem;
    border: 1px solid var(--clr-grey-3);
    border-radius: var(--radius);
    background-color: var(--clr-white);
  }

  p, ul, li {
    font-size: 0.95rem;
  }

  ul {
    padding-left: 1.2rem;
    margin-top: 0.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  h4 {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    color: var(--clr-grey-2);
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .terms-section,
  .refund-section,
  .shipping-section {
    padding: 0 1rem;

    div {
      max-height: none;
      overflow: visible;
      padding: 1rem;
    }

    h3 {
      font-size: 1.1rem;
    }

    h4 {
      font-size: 1rem;
    }

    p, li {
      font-size: 0.9rem;
    }
  }
    

`;

export default Wrapper;
